import $ from 'jquery';

const animations = () => {

	$(window).on('load', function(){
		// width background
		$('.b-upgrade__in').each(function(){
			var $this = $(this),
				offsetTop = $this.offset().top;

			$(window)
				.on('scroll', function(){
					if ( $(document).scrollTop() + ($(window).height() * .75) > offsetTop ) {
						$this.css('width', $this.data('width'));
					}
				});
		});

		// number
		$('.js-counter').each(function(){
			var $this = $(this),
				start = 0,
				end = $this.data('end') * 1,
				step = $this.data('step') * 1,
				animated = false;

			start = start + step;
			$this.text(start);

			var numberWithCommas = function(x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
			};

			var incrementCounter = function(){
				start = start + step;
				if ( start > end ) {
					$this.text( numberWithCommas(end) );
				}
				else{
					$this.text( numberWithCommas(start) );
				}
				if (start < end){
					setTimeout(incrementCounter, 100);
				}
			};

			$(window)
				.on('scroll', function(){
					if ( !animated && ($(window).scrollTop()+ $(window).height()*.75) > $this.offset().top ){
						animated = true;
						incrementCounter();
					}
				});

		});

		// timeline
		$('.c-timeline__item').each(function(){
			var $this = $(this),
				offsetTop = $this.offset().top;

			$(window)
				.on('scroll', function(){
					if ( $(document).scrollTop() + ($(window).height() * .75) > offsetTop ) {
						$this.addClass('is-active');
					}
					else{
						$this.removeClass('is-active');
					}
				});

		});
		$('.c-timeline__wrap').each(function(){
			var $this = $(this),
				$line = $this.find('.c-timeline__line'),
				offsetTop = $this.offset().top;

			$(window)
				.on('scroll', function(e){
					if ( $(document).scrollTop() + ($(window).height() * .75) > offsetTop &&  $(document).scrollTop() + ($(window).height() * .75) < offsetTop + $this.height() - 66) {
						$line.css('height', $(document).scrollTop() + ($(window).height() * .75) - offsetTop);
					}

					if ( e.isTrigger && $(document).scrollTop() + ( $(window).height() * .75) > offsetTop + $this.height() - 66 ) {
						$line.css('height', $this.height() - 66);
					}
				});

		});


		$(window).trigger('scroll');
	});

};

exports.init = animations;



// WEBPACK FOOTER //
// ./src/js/components/animations.js